export enum status {
  UPCOMING = 'UPCOMING',
  T_MINUS_30 = 'TMINUS30',
  LIVE_ENABLED = 'LIVE-ENABLED',
  GOING_LIVE = 'GOING-LIVE',
  PRE_ROLL_INTERSTITIAL = 'PRE-ROLL-INTERSTITIAL',
  LIVE = 'LIVE',
  OVERRUN = 'OVERRUN',
  ENDING_LIVE = 'ENDING-LIVE',
  POST_ROLL_INTERSTITIAL = 'POST-ROLL-INTERSTITIAL',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  RESCHEDULED = 'RESCHEDULED'
}
